import React from "react";
import { getLabel } from "../../../data/labels";

export default function SystemBetsDetailTicketFooter(props) {
    const aamsEnviroment = props.aamsEnviroment

    return (
        <>
            
            <div className="td-100 center">{getLabel('printer.system_bet_details_ticket.footer.reminder')}</div>
            <div className="separator"></div>
            {
			aamsEnviroment &&(
				<div className="center disclaimer_spacing bold">
					Il gioco può causare dipendenza.
					<br/>
					Consulta le probabilità di vincita su www.aams.gov.it
					<br/>
					E' vietato il gioco ai minori di anni 18
				</div>
			)
		    }
        </>
    )
}